import React, { useState } from 'react'
import ModalCancel from '../ModalCancel'
import UseResignOption from '../../../../hooks/use-resign-option'
import { useSelector } from 'react-redux'
import TableListResignPD from './table-list-pd'
import TableListResignIT from './table-list-it'
import TableListResignAdmin from './table-list-admin'

export default function TableListResign({
  orgId,
  dataChecklist,
  page,
  totalLimits,
  isLoading,
  hadleClickIT,
  hadleClickPD,
  hadleClickAdmin,
  getChecklistResign,
  sortDoc,
  sortCode,
  sortLastDate,
  sortName,
  handleSortDoc,
  handleSortCode,
  handleSortLastDate,
  handleSortName,
  clickedColumn,
  statusId
}) {
  const [openCancel, setOpenCancel] = useState(false)
  const [detailById, setDetailById] = useState()
  const resignsOption = UseResignOption()

  const onCancel = () => setOpenCancel(false)
  const isClr = useSelector((state) => state.loginReducer.profile.is_clr_view)
  return (
    <>
      <ModalCancel
        fnData={getChecklistResign}
        resignsOption={resignsOption}
        data={detailById}
        open={openCancel}
        onCancel={onCancel}
        page={page}
        statusId={statusId}
      />
      {/* Admin */}
      {isClr === 1 ? (
        <TableListResignAdmin
        orgId={orgId}
          dataChecklist={dataChecklist}
          page={page}
          totalLimits={totalLimits}
          isLoading={isLoading}
          hadleClickIT={hadleClickIT}
          hadleClickPD={hadleClickPD}
          hadleClickAdmin={hadleClickAdmin}
          getChecklistResign={getChecklistResign}
          sortDoc={sortDoc}
          sortCode={sortCode}
          sortLastDate={sortLastDate}
          sortName={sortName}
          handleSortDoc={handleSortDoc}
          handleSortCode={handleSortCode}
          handleSortLastDate={handleSortLastDate}
          handleSortName={handleSortName}
          clickedColumn={clickedColumn}
          statusId={statusId}
        />
      ) : // IT
      isClr === 2 ? (
        <TableListResignIT
        orgId={orgId}
          dataChecklist={dataChecklist}
          page={page}
          totalLimits={totalLimits}
          isLoading={isLoading}
          hadleClickIT={hadleClickIT}
          hadleClickPD={hadleClickPD}
          hadleClickAdmin={hadleClickAdmin}
          getChecklistResign={getChecklistResign}
          sortDoc={sortDoc}
          sortCode={sortCode}
          sortLastDate={sortLastDate}
          sortName={sortName}
          handleSortDoc={handleSortDoc}
          handleSortCode={handleSortCode}
          handleSortLastDate={handleSortLastDate}
          handleSortName={handleSortName}
          clickedColumn={clickedColumn}
          statusId={statusId}
        />
      ) : // PD
      isClr === 3 ? (
        <>
          <TableListResignPD
          orgId={orgId}
            dataChecklist={dataChecklist}
            page={page}
            totalLimits={totalLimits}
            isLoading={isLoading}
            hadleClickIT={hadleClickIT}
            hadleClickPD={hadleClickPD}
            hadleClickAdmin={hadleClickAdmin}
            getChecklistResign={getChecklistResign}
            sortDoc={sortDoc}
            sortCode={sortCode}
            sortLastDate={sortLastDate}
            sortName={sortName}
            handleSortDoc={handleSortDoc}
            handleSortCode={handleSortCode}
            handleSortLastDate={handleSortLastDate}
            handleSortName={handleSortName}
            clickedColumn={clickedColumn}
            statusId={statusId}
          />
        </>
      ) : null}
    </>
  )
}
